<pv-resident-toolbar
	backAction="custom"
	title="{{ 'general.add_item' | translate: { item: (optionName$ | async | language) } }}"
	(back)="goBack()"
/>

<section class="content">
	<task-types-list [options]="options$ | async" (selectTaskType)="onTaskSelect($event)" />
</section>
